import { Stack } from '@mui/material'
import { TemplateNodeTypeEnum } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useSelector } from 'react-redux'
import { useLimitedFeatureAvailability } from 'src/features/featureAvailability/useLimitedFeatureAvailability'
import { isTableSectionNode } from 'src/features/templateEdit/section/table/model'
import type { RootState } from 'src/state/store'
import DisabledSwitch from './DisabledSwitch'
import EditabilitySwitch from './EditabilitySwitch'
import EnabledAuditSwitch from './EnabledAuditSwitch'
import ExcelSwitch from './ExcelSwitch'
import KeyboardSwitch from './KeyboardSwitch'
import ScoreSwitch from './ScoreSwitch'

const SwitchRow: FC = () => {
  const isActiveEmployeeCheck = useSelector(
    (state: RootState) =>
      Object.values(state.templatesState.templatePages.templateNodes)
        .filter(node => node.type === TemplateNodeTypeEnum.Section)
        .filter(node => node.section?.isEmployeeCheck)?.length > 0,
  )
  const containsTableSection = useSelector((state: RootState) =>
    Object.values(state.templatesState.templatePages.templateNodes).some(
      isTableSectionNode,
    ),
  )
  const isAudit = useSelector(
    (state: RootState) => state.templatesState.editTemplate.isAudit,
  )
  const { isFeatureAvailable } = useLimitedFeatureAvailability()

  // カイゼン機能は従業員チェック・表と併用できない。理由があれば非活性にして Tooltip で示す
  const auditDisabledReason = isActiveEmployeeCheck
    ? '従業員チェックが有効なため、使用できません'
    : containsTableSection
      ? '表を含んでいるひな形では使用できません'
      : undefined

  return (
    <Stack direction="row" sx={{ flexWrap: 'wrap', mx: 2.5 }}>
      <ScoreSwitch />
      {isFeatureAvailable('excelConversionEdit') && <ExcelSwitch />}
      {isFeatureAvailable('improves') &&
        (auditDisabledReason === undefined ? (
          <EnabledAuditSwitch />
        ) : (
          <DisabledSwitch
            tooltip={auditDisabledReason}
            label="カイゼン機能をつける"
            isChecked={isAudit}
          />
        ))}
      <EditabilitySwitch />
      <KeyboardSwitch />
    </Stack>
  )
}

export default SwitchRow
